export enum Department {
  IDoc = "GRAHAL i-doc",
  RAndE = "GRAHAL R&E",
  IPat = "GRAHAL i-pat",
  Formation = "GRAHAL formation"
}
